import clsx from 'clsx';
import React, { useCallback, useEffect } from 'react'
import { Offcanvas } from 'react-bootstrap'
import { useForm } from 'react-hook-form';
import { CreateCategoryFormData, CreateCategorySchema } from '../schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { Category } from '../types';

interface EditCategoryDialogProps {
    show: boolean;
    onClose: () => void;
    category: Category | null;
    onSuccess?: () => void;
}

const EditCategoryDialog: React.FC<EditCategoryDialogProps> = ({ show, onClose, category, onSuccess }) => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm<CreateCategoryFormData>({
        resolver: zodResolver(CreateCategorySchema),
    });

    useEffect(() => {
        if (category) {
            reset({
                name: category.name,
            });
        }
    }, [category, reset]);

    const handleClose = () => {
        reset();
        onClose();
    }

    const onSubmit = useCallback((data: CreateCategoryFormData) => {
        toast.loading('Updating category...', { id: 'update-category' });

        // TODO: Implement API call
        console.log('Updating category:', category?.id, data);

        // Simulate API call
        setTimeout(() => {
            handleClose();
            toast.success('Category updated successfully', { id: 'update-category' });
            onSuccess?.();
        }, 1000);
    }, [category, onSuccess]);

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" className="offcanvas-responsive">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Category</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={handleSubmit(onSubmit)} className="d-flex flex-column" style={{ height: '100%' }}>
                    <div className="action-sheet-content flex-grow-1">
                        {/* Name */}
                        <div className="row mb-3 align-items-center">
                            <label htmlFor="name" className="col-sm-4 col-form-label d-flex justify-content-md-end" style={{ fontSize: '14px' }}>Name: </label>
                            <div className="col-sm-8">
                                <input
                                    type="text"
                                    className={clsx("form-control app-form-control rounded-1", errors?.name && 'is-invalid')}
                                    id="name"
                                    placeholder="Category name"
                                    {...register('name')}
                                    style={{ fontSize: '14px', height: '35px' }}
                                />
                                {errors?.name && <div className="invalid-feedback">{errors.name.message}</div>}
                            </div>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <div className="form-group mt-auto d-grid">
                        <button type="submit" className="btn btn-primary btn-block">
                            Update Category
                        </button>
                    </div>
                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditCategoryDialog